import React from 'react';
import Section from './Section';
import SafeIcon from '../common/SafeIcon';
import { FiCheckCircle } from 'react-icons/fi';

const Solution = () => {
  const points = [
    "Which apps expose you the most",
    "What data they collect (simplified, no jargon)",
    "How that data can be used against you in the real world",
    "Exact steps on what to change immediately"
  ];

  return (
    <div className="bg-zinc-950 text-white">
      <Section>
        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-6">
              Get a Clear Picture of Your Data Risk
            </h2>
            <p className="text-xl text-zinc-400 mb-8">
              Stop guessing. You’ll receive a personalized, actionable report detailing exactly where you stand and how to fix it.
            </p>
          </div>
          <div className="bg-zinc-900 border border-zinc-800 p-8 rounded-2xl">
            <h3 className="text-lg font-semibold text-zinc-300 mb-6 uppercase tracking-wider text-sm">Your Report Includes:</h3>
            <ul className="space-y-4">
              {points.map((point, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <SafeIcon icon={FiCheckCircle} className="w-6 h-6 text-green-400 shrink-0" />
                  <span className="text-zinc-200">{point}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Section>
    </div>
  );
};

export default Solution;